// Global version state wired to the build + backend header.
// CLIENT_VERSION is baked in at build time via REACT_APP_BUILD_VERSION.

const CLIENT_VERSION = process.env.REACT_APP_BUILD_VERSION || "";

let serverVersion = "";
let updateAvailable = false;

const listeners = new Set();
const DISMISSED_UPDATE_KEY = "report360:dismissed-update-pair";

export function versionIdentity(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  return raw.split("-")[0] || raw;
}

function notify() {
  const snapshot = {
    clientVersion: CLIENT_VERSION,
    serverVersion,
    updateAvailable,
  };
  listeners.forEach((fn) => {
    try {
      fn(snapshot);
    } catch {
      // Ignore listener errors
    }
  });
}

function updatePairKey(clientVersion, nextServerVersion) {
  const clientIdentity = versionIdentity(clientVersion);
  const serverIdentity = versionIdentity(nextServerVersion);
  if (!clientIdentity || !serverIdentity) return "";
  return `${clientIdentity}:${serverIdentity}`;
}

function getDismissedUpdatePair() {
  try {
    return window.localStorage.getItem(DISMISSED_UPDATE_KEY) || "";
  } catch {
    return "";
  }
}

function setDismissedUpdatePair(value) {
  try {
    if (value) window.localStorage.setItem(DISMISSED_UPDATE_KEY, value);
  } catch {
    // Ignore storage failures.
  }
}

export function getVersionState() {
  return {
    clientVersion: CLIENT_VERSION,
    serverVersion,
    updateAvailable,
  };
}

export function setServerVersion(nextServerVersion) {
  if (!nextServerVersion || typeof nextServerVersion !== "string") return;
  if (serverVersion === nextServerVersion) return;
  serverVersion = nextServerVersion;
  const clientIdentity = versionIdentity(CLIENT_VERSION);
  const serverIdentity = versionIdentity(serverVersion);
  if (clientIdentity && serverIdentity && serverIdentity !== clientIdentity) {
    const pair = updatePairKey(CLIENT_VERSION, serverVersion);
    updateAvailable = pair !== getDismissedUpdatePair();
  }
  notify();
}

export function clearUpdateFlag() {
  if (serverVersion) {
    setDismissedUpdatePair(updatePairKey(CLIENT_VERSION, serverVersion));
  }
  if (!updateAvailable) return;
  updateAvailable = false;
  notify();
}

export function subscribeVersion(listener) {
  if (typeof listener !== "function") return () => {};
  listeners.add(listener);
  listener({
    clientVersion: CLIENT_VERSION,
    serverVersion,
    updateAvailable,
  });
  return () => {
    listeners.delete(listener);
  };
}

export default CLIENT_VERSION;
